import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import Loader from '../../../Components/Loader/Loader';
import Error from '../../../Components/Error/Error';
import { useChangeRoleStatusMutation, useCreateRoleMutation, useDeleteRoleMutation, usePermissionsQuery, useRolesQuery, useUpdateRoleMutation } from '../../../Store/Apis/rolePermissionApi';
import RoleForm from '../../../Components/RoleForm/RoleForm';

const Roles = () => {
  const [addModalShow, setAddModalShow] = useState(false);
  const roleApi = useRolesQuery({
    keyword: '',
    keynum: '',
  })  
  const permissionApi = usePermissionsQuery()


  // ADD ROLE
  const AddRole = ({addModalShow}) => {
    const [createRole, createRoleResponse] = useCreateRoleMutation()
    const handleAddRoleSubmit = (role) => {
      console.log('Role Submitted:', role);
      // You can send this role to the API or handle it accordingly
      // const role = {
      //   roleName: roleName,
      //   roleStatus: 1,
      //   permissions: selectedPermissions,
      // };
      createRole(role).then((res)=>{
        setAddModalShow(false)
      })
    };

    return(
      <Modal show={addModalShow} onHide={()=>setAddModalShow(false)} size='lg' centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <RoleForm 
              permissionsList={permissionApi.isSuccess ? permissionApi?.data?.data : []} 
              onSubmit={handleAddRoleSubmit}
            />
        </Modal.Body>
      </Modal>
    )
  }

  // UPDATE ROLE
  const [updateRole, updateRoleResponse] = useUpdateRoleMutation()
  const [selectedEditRole, setSelectedEditRole] = useState(false);
  const handleSubmit = (role) => {
      console.log('Role Submitted:', role);
      // You can send this role to the API or handle it accordingly
      updateRole(role).then((res)=>{
        setSelectedEditRole(null)
      })
  };


  // STATUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useChangeRoleStatusMutation()
  const handleChangeStatus = () => {
    console.log(selectedStatus)
    // changeStatus(selectedStatus).then((res)=>{
    //   console.log(res)
    //   setSelectedStatus(null)
    // })
    changeStatus({
      keyID: selectedStatus.roleID,
      isActive: selectedStatus.roleStatus === 0 ? 1 : 0,
    }).then((res)=>{
      setSelectedStatus(null)
    })
  }

  
  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteRole] = useDeleteRoleMutation()
  const handleDelete = () => {
    deleteRole(selectedRecord.roleID).then((res)=>{
      setSelectedRecord(null)
    })
  }
  

  
  return (
    <div>
      <div className="row align-items-center justify-content-between mb-3">
        <div className="col">
          <h5 className="fw-500 text-white mb-0">Roles</h5>
        </div>
        <div className="col-auto">
          <Link onClick={() => setAddModalShow(true)} className="btn btn-icon btn-3 btn-white text-primary mb-0">
            <i className="fa fa-plus me-2"></i> Add New Roles
          </Link>
          <AddRole addModalShow={addModalShow}/>
        </div>
      </div>
      <div className="card">
        <div className="card-header p-4">
          <div className="row">
            <div className="col-md-12">
              <input
                type="text"
                className="form-control"
                placeholder="Search here"
              />
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          {roleApi.isError && <Error/>}
          {roleApi.isLoading && <Loader height="500px"/>}
          {
            roleApi.isSuccess && (
              <div className="table-responsive">
                <table className="table align-items-center mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th className="text-uppercase text-secondary text-xs opacity-7">
                        Role Name
                      </th>
                      <th className="text-uppercase text-secondary text-xs opacity-7">
                        Status
                      </th>
                      <th className="text-secondary opacity-7" />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      roleApi.data.data.map((elem, i)=>{
                        return (
                          <>                          
                            {/* <RoleTableRow permissionsList={permissionApi?.data?.data} elem={elem} index={i} key={i}/> */}
                            <tr  key={i}>                        
                              <td className='w-100 px-4'>
                                <p className="text-sm mb-0">{elem.roleName}</p>
                              </td>
                              <td className="align-middle px-4">
                                <button 
                                  type='button' 
                                  className={`btn badge badge-xs ${elem.roleStatus == 1 ? 'badge-success': 'badge-danger'} fw-600 text-xs mb-0`} 
                                  onClick={() => setSelectedStatus(elem)}
                                >
                                    {elem.roleStatus == 1 ? 'Active': 'Deactivated'}
                                </button>
                              </td>
                              <td className='text-end px-4'>
                                <button 
                                  className="btn badge badge-xs badge-warning fw-600 text-xs mb-0 mx-2" 
                                  onClick={()=>setSelectedEditRole(elem)}
                                >View & Edit</button>
                                <button 
                                  className="btn badge badge-xs badge-danger fw-600 text-xs mb-0 mx-2"
                                  onClick={()=>setSelectedRecord(elem)}  
                                >Delete</button>
                              </td>
                            </tr>
                          </>                      
                        )
                      })
                    }
                  </tbody>
                </table>
              </div>
            )
          }
        </div>
      </div>

      {/* UPDATE ROLE FORM */}
      {
        selectedEditRole && 
        <Modal show={selectedEditRole} onHide={()=>setSelectedEditRole(null)} size='lg' centered>
          <Modal.Header closeButton>
            <Modal.Title>View & Edit Role & Permissions for {selectedEditRole && selectedEditRole.roleName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <RoleForm 
                roleId={selectedEditRole.roleID}
                permissionsList = {permissionApi?.data?.data}
                onSubmit={handleSubmit}
              />
          </Modal.Body>
        </Modal>
      }


      {/* STATUS CHANGE MODAL */}
      <Modal 
          show={selectedStatus} 
          onHide={() => setSelectedStatus(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to change status?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedStatus(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>
      {/* DELETE MODAL */}
      <Modal  
          show={selectedRecord} 
          onHide={() => setSelectedRecord(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to delete the customer?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>
    </div>
  )
}

export default Roles